<div class="tp-page tp-page--compact score-container">
  <section class="tp-card tp-card--flush">
    <tp-page-header variant="toolbar" title="Score"
    [subtitle]="contractorsScore.length + ' prestadores'">
    </tp-page-header>
    <div class="tp-table-responsive table-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="announceSortChange($event)"
      >
        <ng-container matColumnDef="ranking">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by ranking"
          >
            <span>Ranking</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="ranking-cell" (click)="goScoreDetail(element.providerId)">
              <img
                class="cup"
                src="../assets/score-icons/Trophy_perspective_matte.svg"
                alt=""
              />
              <span class="ranking-cell__value">{{ element.ranking }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="points">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by points"
          >
            <span>Puntos</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="points-align" (click)="goScoreDetail(element.providerId)">
              <span class="points-value">{{ element.points }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="fullName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by fullName"
            class="contractor-header"
          >
            <span>Prestadores</span>
          </th>
          <td mat-cell *matCellDef="let element" class="contractor-header">
            <div class="contractor-cell" (click)="goScoreDetail(element.providerId)">
              <div class="avatar-container">
                <div
                  class="avatar"
                  [style.background]="
                    'url(' + imageSvc.getImage(element.url) + ')'
                  "
                ></div>
              </div>
              <div class="contractor-cell__text">
                <span class="truncate">{{ element.fullName }}</span>
                <span class="dni">{{ element.dni }}</span>
              </div>
            </div>
          </td>
        </ng-container>
        @for (score of contractorsScore[0]?.scores; track score; let i = $index) {
          <ng-container
            [matColumnDef]="score.factorName"
          >
            <th class="dynamic-header" mat-header-cell *matHeaderCellDef>
              {{ score.factorName }}
            </th>
            <td
              class="dynamic-cell"
              mat-cell
              *matCellDef="let element"
              (click)="goScoreDetail(element.providerId)"
            >
              {{ getScoreValue(element, score.factorName) }}
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          style="cursor: pointer"
        ></tr>
      </table>
      @if (displayedColumns.length && dataSource.data.length === 0) {
        <tp-empty-state
          icon="leaderboard"
          title="Todavía no hay puntajes"
          message="Cuando los prestadores sumen puntos los vas a ver en el ranking."
        ></tp-empty-state>
      }
    </div>
    <mat-paginator
      class="tp-list-page__paginator"
      [pageSizeOptions]="[10, 20, 30]"
      aria-label="Select page of budgets"
    ></mat-paginator>
  </section>
</div>
